export default "__VITE_ASSET__29536bba__"